module.exports = __webpack_public_path__ + "fonts/Averta-Regular.8d4fada.otf";